import React, { useCallback, useState, useMemo } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import useModel from '../../../common/useModel'

import Ingredient from './ingredient'
import Translates from './translates'
import { SaveButton, ConfirmModal, EditorTransitionPrompt, IngredientsModal } from  '../../../components'
import actions from './actions'
import { Loading } from  '../../../components'

import {
  getIngredient as getIngredientAction,
  addIngredient as addIngredientAction,
  updateIngredient as updateIngredientAction,
} from './storeActions'

const defaultIngredient = {
  name: '',
  ingredientStatus: 'draft',
  availableRegions: [],
  translates: {},
  blsLink: '',
}

const IngredientView = props => {

  const {
    locales,
    match,
    ingredient = defaultIngredient,
  } = props

  const isNew = match.params.ingredientId === 'new'
  const [showNewOption, setShowNewOption] = useState(isNew)
  const [showIngredients, setShowIngredients] = useState(false)

  const initialModel = useMemo(() => ({
    values: isNew ? defaultIngredient : ingredient,
  }), [ingredient, isNew])

  const model = useModel(initialModel)

  const handleUseIngredient = useCallback(ingredients => {
    const copy = JSON.parse(JSON.stringify(ingredients[0]))
    delete copy.id
    copy.name = `${copy.name} - copy`
    model.batchChange({ values: copy })
    setShowIngredients(false)
  }, [model])

  const [resetOpened, setResetOpen] = useState(false)

  const { onSave, onAdd, saving } = actions({ ...props, resetDirty: model.resetDirty })

  const handleSave = useCallback(() => {
    isNew ? onAdd(model.values) : onSave(model.values)
  }, [isNew, model.values, onAdd, onSave])

  const handleReset = useCallback(() => {
    setResetOpen(true)
  }, [])

  return (
    <div>
      {
        locales && locales.length > 0 ? (
          <React.Fragment>
            <EditorTransitionPrompt when={model.isDirty}/>
            <Ingredient {...props} model={model} />
            <Translates {...props} model={model} />
            <SaveButton
              disabled={!model.isValid || !model.isDirty}
              onClick={handleSave}
              canCancel={model.isDirty}
              onCancel={handleReset}
            />
            {
              resetOpened && (
                <ConfirmModal
                  isOpened
                  onClose={() => setResetOpen(false)}
                  onConfirm={() => {
                    model.reset('values')
                    setResetOpen(false)
                  }}
                  redConfirm
                >
                  Are you sure you want to reset fields?
                </ConfirmModal>
              )
            }
          </React.Fragment>
        ) : <div>Please create at least one locale, region and food category first</div>
      }
      {
        saving && <Loading overlay />
      }
      {
        showIngredients && (
          <IngredientsModal
            onClose={() => setShowIngredients(false)}
            onChange={handleUseIngredient}
            fullWidth
            title="Copy ingredient"
            multi={false}
            returnOriginals
          />
        )
      }
      {
        !!showNewOption && (
          <ConfirmModal
            isOpened
            onClose={() => setShowNewOption(false)}
            onConfirm={() => {
              setShowNewOption(false)
              setShowIngredients(true)
            }}
            confirmTitle="Copy existing ingredient"
            cancelTitle="Create from zero"
          >
              How would you like to create new ingredient?
          </ConfirmModal>
        )
      }
    </div>
  )
}

const mapStateToProps = (state, { entityName }) => ({
  foodKinds: state.foodKinds.list,
  regions: state.regions.list,
  locales: state.locales.list,
  ingredient: state.ingredients.item,
  role: state.session.role,
})

const mapDispatchToProps = (dispatch, { entityName } ) => ({
  getIngredient: entityId => dispatch(getIngredientAction(entityId)),
  addIngredient: item => dispatch(addIngredientAction(item)),
  updateIngredient: (entityId, item) => dispatch(updateIngredientAction(entityId, item)),
})

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(IngredientView))
